import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ControlValueAccessor } from '@angular/forms';
import * as VMasker from 'vanilla-masker';

@Directive({
    selector: '[DateMask]',
})
export class DateMaskDirective implements ControlValueAccessor {
    public nativeElement: HTMLInputElement;

    constructor(
        public element: ElementRef,
        private control: NgControl,
    ) {
        this.registerOnChange(null);
    }

    /**
     * Propaga mudanças para componentes externos
     */
    public propagateChange = (_: any) => {
        //
    }

    public writeValue(value: any) {
        //
    }

    public onChange(val) {
        //
    }

    public registerOnChange(fn: any) {
        this.propagateChange = fn;
    }

    public ngAfterContentInit() {
        this.control.control.valueChanges.subscribe((e) => {
            this.control.control
                .setValue(VMasker.toPattern('99/99/9999', this.element.nativeElement.value), { emitEvent: false });
        });
    }

    /**
     * Marcar campo externo como tocado no blur do input
     */
    public registerOnTouched() {
        //
    }

    @HostListener('input', ['$event'])
    public onEvent($event) {
        this._mask();
    }

    private _mask() {
        VMasker(this.element.nativeElement)
            .maskPattern('99/99/9999');
    }
}
